<template>
  <b-overlay
    :show="loading"
    spinner-variant="primary"
    spinner-type="grow"
    spinner-small
    rounded="sm"
  >
  <div class="measurements-container" v-if="measuresDisplay">
    <div class="popup-content">
      <div class="popup-content-inner">
        <div class="popup-top">
          <div class="points-count">
            <div class="legend">Face Datapoints captured:</div>
            <div class="pt-value">{{pointCloudLineCount}}.</div>
          </div>
          <div class="close-button" @click.prevent="measuresDisplay=!measuresDisplay">
              
                <img width="8" src="/assets/images/arrownew.svg" />

            </div>
            <div class="scan-name">
              <div class="scan-button">
                <div class="initiales">{{ scan.name[0] }}.</div>
                <span class="name">{{ scan.name }}</span>
                <span class="date">{{ scan.date }}</span>
              </div>
            </div>

            <div class="scans-canvas"  >
              <scan-canvas-popup v-if="scan" :scan="scan" />
        
            </div>
          </div>

          <div class="measures-content-inner">
          <div class="measures-big">
          <div class="scan-measures" v-if="measurements">
          
            <div class="title">
              <div class="title-icon"><img src="/assets/images/measures.svg" /></div>
               Morphological Measurements
            </div>

            <template>
              <br />
              
              <span class="label">Cantus Distance:</span> <span class="value">{{ measurements.CantusDistance}}mm</span><br />
            
            <span class="label">Sphenoidal Width :</span> <span class="value">{{ measurements.SpenoidalWidth}}mm</span><br />
            <span class="label">Temple Width:</span> <span class="value">{{ measurements.TempleDistance}}mm</span><br />
            <span class="label">Pantoscopic Angle:</span> <span class="value">{{ measurements.PantoscopicAngle}}°</span><br />
           


            <span class="label">Eyebrow Height :</span> <span class="value">{{ measurements.EyeBrowHeight}}mm</span><br />
            <span class="label">Cheekbone Height :</span> <span class="value">{{ measurements.CheekboneHeight}}mm</span><br />
          
    <!-- 
              Auricular Width : {{ measurements.AuricularWidth}} <br />
              Nasal height : {{ measurements.NasalHeight}}<br />
              Unprojected auricular width :  {{ measurements.UnprojectedAuricularWidth }} -->
            </template>

          
          </div>
        </div>
        <div class="measures-half">
          <div class="measures-small">
            <div class="scan-measures" v-if="measurements">
            
              <div class="title">
                <div class="title-icon"><img src="/assets/images/measures.svg" /></div>
                Optical Measurements
              </div>

              <template>
                <br />
                <span class="label">Eye to lens distance (Topological):</span> <span class="value">{{ measurements.EyeToLensDistance}}mm</span><br />
                <span class="label">Final eye to lens distance:</span> <span class="value">{{ goodEyeToLensDistance }}mm</span><br />
                <span class="label">Close Pupillary Distance:</span> <span class="value">{{ measurements.PupillaryDistance}}mm</span><br />
                <span class="label">Far Pupillary Distance:</span> <span class="value">{{ measurements.FarPupillaryDistance ? measurements.FarPupillaryDistance : measurements.PupillaryDistance*1+4}}mm</span><br />
                <span class="label">Pupillary Height:</span> <span class="value">{{ goodPupillaryHeight }}mm</span><br />
      <!-- 
                Auricular Width : {{ measurements.AuricularWidth}} <br />
                Nasal height : {{ measurements.NasalHeight}}<br />
                Unprojected auricular width :  {{ measurements.UnprojectedAuricularWidth }} -->
              </template>

            
            </div>
          </div>
          <div class="measures-small">
            <div class="scan-measures" v-if="measurements">
            
              <div class="title">
                <div class="title-icon"><img src="/assets/images/measures.svg" /></div>
                Nasal Measurements
              </div>

              <template>
                <br />
              
                <span class="label">Right Nasal Face Angle :</span> <span class="value">{{ measurements.RightNasalFaceAngle}}°</span>  <br />
                <span class="label">Left Nasal Face Angle :</span> <span class="value">{{ measurements.LeftNasalFaceAngle}}°</span><br />

                
                <span class="label">Right Nasal Caster Angle :</span> <span class="value">{{ measurements.RightNasalCasterAngle}}°</span><br />
                <span class="label">Left Nasal Caster Angle :</span> <span class="value">{{ measurements.LeftNasalCasterAngle}}°</span><br />
    
                <span class="label">Nasal Crete Angle :</span> <span class="value">{{ measurements.NoseCreteAngle}}°</span><br />
                <!--
                <span class="label">Nasal Bone Width :</span> <span class="value">{{ measurements.NasalWidth}}mm</span> <br />
               
                <span class="label">Nasal height:</span> <span class="value">{{ measurements.NasalHeight}}mm</span><br />
              -->
                
              </template>

            
            </div>
          </div>
        </div>
        
       <!-- GLOBAL SCORE : {{ fittingLogs.global_score }} ({{ sizeFeedBackInfo }} x 0.5 + {{ framePositionInfo.split('-')[1] }} x 0.3 + {{ noseComfortInfo }} x 0.15 + {{earFitInfo}} x 0.05)-->
      </div>
    </div>
    </div>
  </div>
  <div class="fitting-container" v-if="fittingLogs">
    
    <div class="fitting-content">
      <div class="title-line">
        <div class="left">
          <div class="fit-balise good">
              
             
              
              <span class="fit-balise-name">
               Complete

              </span>
            </div>

          Fit Report
        </div>
        <div class="right">
          <div class="right-item" v-if="glass">
            <div class="label">Model</div>
            <div class="value">{{ glass.name }}</div>
          </div>
          <div class="right-item" v-if="scan">
            <div class="label">Scan</div>
            <div class="value">{{ scan.name }}</div>
          </div>
          <div class="right-item" v-if="scan">
            <div class="label">Scan ID</div>
            <div class="value">#{{ scan.id }}</div>
          </div>
          <div class="right-item" v-if="scan">
            <div class="label">Date of scan</div>
            <div class="value">{{ scan.date }}</div>
          </div>
        </div>
      </div>
      <div class="fitting-content-inner">
        <div class="fitting-top">
            <div class="scans-canvas"  >
              <scan-canvas v-if="scan" :scan="scan" @displayMeasurementsEv="displayMeasurements" :displayMeasures="measuresDisplay" />
        
            </div>

            
              
          
          
          <div class="fitting-description" >
          
              <div class="fit-balise" :class="{'good':fittingLogs.global_score>=70,'low':fittingLogs.global_score<40,'medium':fittingLogs.global_score>=40 && fittingLogs.global_score<70}">
                
                <template v-if="fittingLogs.global_score>=70">
                  <img src="/assets/images/fit-good.png" width="16" /> 
                </template>
                <template v-else-if="fittingLogs.global_score<40">
                  <img src="/assets/images/fit-low.png"  width="16" /> 
                </template>
                <template v-else>
                  <img src="/assets/images/fit-medium.png"  width="16" /> 
                </template>
                
                
                <span class="fit-balise-name">
                  <template v-if="fittingLogs.global_score>=70">
                    Great Fit
                  </template>
                  <template v-else-if="fittingLogs.global_score<40">
                    Needs Adjustment
                  </template>
                  <template v-else>
                    Average Fit
                  </template>

                </span>
              </div>
            
              <div>
              <div class="recommended"><span class="b">Size <span class="sizename">{{ fittingLogs.final_size }}</span></span> is the best match for your facial measurements.</div>
              <div class="recommended-sizes medium">
                
                <div class="size" :class="{active:fittingLogs.final_size=='xs',good:isSizeInGoodAdjustments('xs')}">
                  <div class="size-content">
                    <div class="size-score" :style="{height:fittingLogs.size_feedback_result_xs.split('-')[1]+'%'}">
                    
                    </div>
                  
                  </div>
                  <div class="size-name">XS</div>
                  
                </div>
                <div class="size" :class="{active:fittingLogs.final_size=='s',good:isSizeInGoodAdjustments('s')}">
                  <div class="size-content">
                    <div class="size-score"  :style="{height:fittingLogs.size_feedback_result_s.split('-')[1]+'%'}">
                    
                    </div>
                    
                  </div>
                  <div class="size-name">S</div>
                </div>
                <div class="size" :class="{active:fittingLogs.final_size=='m',good:isSizeInGoodAdjustments('m')}">
                  <div class="size-content">
                    <div class="size-score" :style="{height:fittingLogs.size_feedback_result_m.split('-')[1]+'%'}"></div>
                  
                  
                  </div>
                  <div class="size-name">M</div>
                </div>
                <div class="size" :class="{active:fittingLogs.final_size=='l',good:isSizeInGoodAdjustments('l')}">
                  <div class="size-content">
                    <div class="size-score" :style="{height:fittingLogs.size_feedback_result_l.split('-')[1]+'%'}"></div>
                    
                  </div>
                  <div class="size-name">L</div>
                </div>
                <div class="size" :class="{active:fittingLogs.final_size=='xl',good:isSizeInGoodAdjustments('xl')}">
                  <div class="size-content">
                    <div class="size-score"  :style="{height:fittingLogs.size_feedback_result_xl.split('-')[1]+'%'}"></div>
                    
                  </div>
                  <div class="size-name">XL</div>
                </div>
              </div>
            </div>
            <!--<div class="desc-bottom">
              Best fit ! <span class="grey">Harciaerro et ea coria inverchici.</span>
            </div>-->
          </div>

        </div>
        
        <template v-if="!measuresDisplay">
        <div class="fitting-infos-content">
          <div class="fitting-infos">
            <div class="fitting-info">
              <div class="fitting-info-title">Frame size</div>

              <div class="fit-balise little-fit-balise" :class="{'good':sizeFeedBackInfo.split('-')[1]>=70,'low':sizeFeedBackInfo.split('-')[1]<40,'medium':sizeFeedBackInfo.split('-')[1]>=40 && sizeFeedBackInfo.split('-')[1]<70}">
              
                <span class="fit-balise-name">
                <template v-if="sizeFeedBackInfo.split('-')[1]>=70">
                    Well Sized
                </template>
                <template v-else-if="sizeFeedBackInfo.split('-')[1]>=40">
                  <template v-if="sizeFeedBackInfo.split('-')[0]==1">
                    Slightly Large
                  </template>
                  <template v-else>
                    Slightly Small
                  </template>
                
                </template>
                <template v-else>
                  <template v-if="sizeFeedBackInfo.split('-')[0]==1">
                    Large
                  </template>
                  <template v-else>
                    Small
                  </template>
                </template>

                </span>
              </div>
              
              <div class="fitting-info-range">
               
                <div class="range-content-wrap">
                  <div class="range-cursor-text" :class="{'right':sizeFeedBackInfo.split('-')[0]==1 ? ((100 - sizeFeedBackInfo.split('-')[1]) * 0.4)==50 : ((sizeFeedBackInfo.split('-')[1] - 100) * 0.4)==50,'left':sizeFeedBackInfo.split('-')[0]==1 ? ((100 - sizeFeedBackInfo.split('-')[1]) * 0.4)==50 : ((sizeFeedBackInfo.split('-')[1] - 100) * 0.4)==50}" :style="'margin-left:'+(sizeFeedBackInfo.split('-')[0]==1 ? ((100 - sizeFeedBackInfo.split('-')[1]) * 0.4)+'%' : ((sizeFeedBackInfo.split('-')[1] - 100) * 0.4)+'%')">
                    <div class="cursor-point"  :class="{'medium':sizeFeedBackInfo.split('-')[1]<70 && sizeFeedBackInfo.split('-')[1]>40,'low':sizeFeedBackInfo.split('-')[1]<=40}"></div>  
                  </div>
                  <div class="range-content">
                    <div class="range-cursor" :class="{'right':sizeFeedBackInfo.split('-')[0]==1 ? ((100 - sizeFeedBackInfo.split('-')[1]) * 0.4)==50 : ((sizeFeedBackInfo.split('-')[1] - 100) * 0.4)==50,'left':sizeFeedBackInfo.split('-')[0]==1 ? ((100 - sizeFeedBackInfo.split('-')[1]) * 0.4)==50 : ((sizeFeedBackInfo.split('-')[1] - 100) * 0.4)==50,'medium':sizeFeedBackInfo.split('-')[1]<70 && sizeFeedBackInfo.split('-')[1]>40,'low':sizeFeedBackInfo.split('-')[1]<=40}" :style="'width:'+(sizeFeedBackInfo.split('-')[0]==1 ? (50+(100 - sizeFeedBackInfo.split('-')[1]) * 0.4)+'%' : (50+(sizeFeedBackInfo.split('-')[1] - 100) * 0.4)+'%')"></div>
                  </div>
                </div>

              </div>
              <div class="range-legend-ruler">
               
                
              </div>
              <div class="range-legend-content">
                <div class="min-range">Small</div>
                <div class="mid-range">Well Sized</div>
                <div class="max-range">Large</div>
              </div>
              <div class="fitting-info-content">

                <span class="grey">

                  The frame looks 
                  <template v-if="sizeFeedBackInfo.split('-')[1]>=70">
                    well sized
                  </template>
                  <template v-else-if="sizeFeedBackInfo.split('-')[1]>=40">
                    <template v-if="sizeFeedBackInfo.split('-')[0]==1">
                      slightly large
                    </template>
                    <template v-else>
                      slightly small
                    </template>
                  
                  </template>
                  <template v-else>
                    <template v-if="sizeFeedBackInfo.split('-')[0]==1">
                      large
                    </template>
                    <template v-else>
                      small
                    </template>
                  </template>
                  on your face — your pupils sit 
                  <template v-if="sizeFeedBackInfo.split('-')[1]>=70">
                    well positioned within the lenses
                  </template>
                  <template v-else-if="sizeFeedBackInfo.split('-')[1]>=40">
                    <template v-if="sizeFeedBackInfo.split('-')[0]==1">
                      with extra space to the lens edges
                    </template>
                    <template v-else>
                      a bit close to the lens edges
                    </template>
                  
                  </template>
                  <template v-else>
                    <template v-if="sizeFeedBackInfo.split('-')[0]==1">
                      with a lot of space to the lens edges
                    </template>
                    <template v-else>
                      close to the lens edges
                    </template>
                  </template>


                  </span>

                </div>
            </div>

            <div class="fitting-info">
              <div class="fitting-info-title">Height on your face</div>

              <div class="fit-balise little-fit-balise" :class="{'good':framePositionInfo.split('-')[1]>=70,'low':framePositionInfo.split('-')[1]<40,'medium':framePositionInfo.split('-')[1]>=40 && framePositionInfo.split('-')[1]<70}">
              
                <span class="fit-balise-name">
                  <template v-if="framePositionInfo.split('-')[1]>=70">
                    Well Centered
                  </template>
                  <template v-else-if="framePositionInfo.split('-')[1]>=40">
                    <template v-if="framePositionInfo.split('-')[0]==1">
                      Slightly High
                    </template>
                    <template v-else>
                      Slightly Low
                    </template>
                  
                  </template>
                  <template v-else>
                    <template v-if="framePositionInfo.split('-')[0]==1">
                      High
                    </template>
                    <template v-else>
                      Low
                    </template>
                  </template>

                </span>
              </div>
              
              <div class="fitting-info-range">
                
                <div class="range-content-wrap">

                  <div class="range-cursor-text" :style="'margin-left:'+(framePositionInfo.split('-')[0]==1 ? ((100 - framePositionInfo.split('-')[1]) * 0.4)+'%' : ((framePositionInfo.split('-')[1] - 100) * 0.4)+'%')">
                    <div class="cursor-point"  :class="{'medium':framePositionInfo.split('-')[1]<70 && framePositionInfo.split('-')[1]>40,'low':framePositionInfo.split('-')[1]<=40}"></div>
                  </div>
                  <div class="range-content">
                    
                    <div class="range-cursor" :class="{'medium':framePositionInfo.split('-')[1]<70 && framePositionInfo.split('-')[1]>40,'low':framePositionInfo.split('-')[1]<=40}" :style="'width:'+(framePositionInfo.split('-')[0]==1 ? (50+(100 - framePositionInfo.split('-')[1]) * 0.4)+'%' : (50+(framePositionInfo.split('-')[1] - 100) * 0.4)+'%')"></div>
                  </div>
                </div>
                
              </div>
              <div class="range-legend-ruler">
                
                
              </div>
              <div class="range-legend-content">
                <div class="min-range">Low</div>
                <div class="mid-range">Well Centered</div>
                <div class="max-range">High</div>
              </div>
              <div class="fitting-info-content">

                <span class="grey">
                  
                  The frame sits 
                <template v-if="framePositionInfo.split('-')[1]>=70">
                  well centered  
                </template>
                <template v-else-if="framePositionInfo.split('-')[1]>=40">
                  <template v-if="framePositionInfo.split('-')[0]==1">
                    slightly high 
                  </template>
                  <template v-else>
                    slightly low 
                  </template>
                 
                </template>
                <template v-else>
                  <template v-if="framePositionInfo.split('-')[0]==1">
                    high 
                  </template>
                  <template v-else>
                    low 
                  </template>
                </template>
                 relative to your eyes.
                  
                 </span>

              </div>
            </div>
          </div>
        
          <div class="fitting-infos">
            <div class="fitting-info">
              <div class="fitting-info-title">Nose Support & Balance</div>

              <div class="fit-balise little-fit-balise" :class="{'good':noseComfortInfo>=70,'low':noseComfortInfo<40,'medium':noseComfortInfo>=40 && noseComfortInfo<70}">
              
                <span class="fit-balise-name">
                  <template v-if="noseComfortInfo>=70">
                    Comfortable
                  </template>
                  <template v-else-if="noseComfortInfo>=40">
                  
                    Adequate
                  </template>
                  <template v-else>
                    Needs Adjustment
                  </template>

                </span>
              </div>
              
              <div class="fitting-info-range">
               
                <div class="range-content-wrap">
                  <div class="range-cursor-text"  :style="{ left: noseComfortInfo + '%' }">
                    <div class="cursor-point"   :class="{'medium':noseComfortInfo<70 && noseComfortInfo>40,'low':noseComfortInfo<=40}"></div>
                  </div>
                  <div class="range-content">
                  <div class="range-cursor" :class="{'medium':noseComfortInfo<70 && noseComfortInfo>40,'low':noseComfortInfo<=40}" :style="{ width: noseComfortInfo + '%' }"></div>
                  </div>
                </div>
               
              </div>

              <div class="range-legend-ruler style2">
                
                
              </div>
              <div class="range-legend-content">
                <div class="min-range">Needs Adjustment</div>
                <div class="mid-range">Adequate</div>
                <div class="max-range">Comfortable</div>
              </div>
              
              <div class="fitting-info-content">
               <!--
                <div class="small-ranges">
                  
                  <div class="small-range">
                    <div class="fitting-info-title-small">Face Angle Pressure</div>
                    <div class="fitting-info-range">
              
                      <div class="range-content-wrap">
                        <div class="range-cursor-text" :class="{'right':earOcclusionInfo.split('-')[1]==100,'left':earOcclusionInfo.split('-')[1]==0}" :style="{ left: earOcclusionInfo.split('-')[1] + '%' }">
                          <div class="cursor-point"  :class="{'medium':earOcclusionInfo.split('-')[1]<70 && earOcclusionInfo.split('-')[1]>40,'low':earOcclusionInfo.split('-')[1]<=40}"></div>
                        </div>
                        <div class="range-content">
                          <div class="range-cursor" :class="{'medium':earOcclusionInfo.split('-')[1]<70 && earOcclusionInfo.split('-')[1]>40,'low':earOcclusionInfo.split('-')[1]<=40}" :style="{ width: earOcclusionInfo.split('-')[1] + '%' }"></div>
                        </div>
                      </div>
                      
                    </div>
                    <div class="range-legend-ruler little">
                      
                      
                    </div>
                    <div class="range-legend-content">
                      <div class="min-range">Needs refining</div>
                      <div class="mid-range">Adequate</div>
                      <div class="max-range">Optimized</div>
                    </div>
                  </div>
                  <div class="small-range">
                    <div class="fitting-info-title-small">Caster angle</div>
                    <div class="fitting-info-range">
                      
                      <div class="range-content-wrap">
                        <div class="range-cursor-text" :class="{'right':earOcclusionInfo.split('-')[1]==100,'left':earOcclusionInfo.split('-')[1]==0}" :style="{ left: earOcclusionInfo.split('-')[1] + '%' }">
                          <div class="cursor-point"  :class="{'medium':earOcclusionInfo.split('-')[1]<70 && earOcclusionInfo.split('-')[1]>40,'low':earOcclusionInfo.split('-')[1]<=40}"></div>
                        </div>
                        <div class="range-content">
                          <div class="range-cursor" :class="{'medium':earOcclusionInfo.split('-')[1]<70 && earOcclusionInfo.split('-')[1]>40,'low':earOcclusionInfo.split('-')[1]<=40,'right':earOcclusionInfo.split('-')[1]==100,'left':earOcclusionInfo.split('-')[1]==0}" :style="{ left: earOcclusionInfo.split('-')[1] + '%' }"></div>
                        </div>
                      </div>
                      
                    </div>
                    <div class="range-legend-ruler little">
                     
                      
                    </div>
                    <div class="range-legend-content">
                      <div class="min-range">Needs refining</div>
                      <div class="mid-range">Adequate</div>
                      <div class="max-range">Optimized</div>
                    </div>
                  </div>
                  
                </div>
                <br />
                -->
                <span class="grey">
                  Nose comfort 
                  <template v-if="noseComfortInfo>=70">
                    is comfortable 
                  </template>
                  <template v-else-if="noseComfortInfo>=40">
                  
                    is adequate 
                  </template>
                  <template v-else>
                    needs adjustment 
                  </template>
                  , mainly because 
                  <template v-if="faceAngleInfo.split('-')[1]>=70 && casterAngleInfo.split('-')[1]>=70">
                    pressure is evenly distributed on your nose.
                  </template>
                  
                  <template v-else>
                    the nose pad face angle is 

                    <template v-if="faceAngleInfo.split('-')[1]==70">
                      concentrated lower on your nose
                    </template>
                    <template v-else-if="faceAngleInfo.split('-')[1]==100">

                      evenly distributed on your nose
                    </template>

                    <template v-else-if="faceAngleInfo.split('-')[1]==30">
                      
                      concentrated higher on your nose bone
                    </template>

                    <template v-else>
                      <template v-if="faceAngleInfo.split('-')[0]==1">
                        concentrated lower on your nose
                      </template>
                      <template v-else>
                        concentrated higher on your nose bone
                      </template>
                    </template>
                    and the caster angle is

                    <template v-if="casterAngleInfo.split('-')[1]==70">
                      slightly back loaded
                    </template>
                    <template v-else-if="casterAngleInfo.split('-')[1]==100">

                      balanced
                    </template>

                    <template v-else-if="casterAngleInfo.split('-')[1]==30">
                      
                      slightly front loaded
                    </template>

                    <template v-else>
                      <template v-if="casterAngleInfo.split('-')[0]==1">
                        considerably  back loaded
                      </template>
                      <template v-else>
                        considerably  front loaded
                      </template>
                    </template>
                  </template>

                </span>

              </div>
            </div>

            <div class="fitting-info">
              <div class="fitting-info-title">Temple fit</div>

              <div class="fit-balise little-fit-balise" :class="{'good':earOcclusionInfo.split('-')[1]>=70,'low':earOcclusionInfo.split('-')[1]<40,'medium':earOcclusionInfo.split('-')[1]>=40 && earOcclusionInfo.split('-')[1]<70}">
              
                <span class="fit-balise-name">
                  <template v-if="earOcclusionInfo.split('-')[1]>=70">
                    Well Adjusted
                  </template>
                  <template v-else-if="earOcclusionInfo.split('-')[1]>=40">
                  
                    Adequate
                  </template>
                  <template v-else>
                    Needs Adjustment
                  </template>

                </span>
              </div>
              <div class="fitting-info-range">
              
                <div class="range-content-wrap">
                  <div class="range-cursor-text"  :style="{ left: earOcclusionInfo.split('-')[1] + '%' }">
                    <div class="cursor-point"  :class="{'medium':earOcclusionInfo.split('-')[1]<70 && earOcclusionInfo.split('-')[1]>40,'low':earOcclusionInfo.split('-')[1]<=40}"></div>
                  </div>
                  <div class="range-content">
                    <div class="range-cursor" :class="{'medium':earOcclusionInfo.split('-')[1]<70 && earOcclusionInfo.split('-')[1]>40,'low':earOcclusionInfo.split('-')[1]<=40}" :style="{ width: earOcclusionInfo.split('-')[1] + '%' }"></div>
                  </div>
                </div>
                
              </div>
              <div class="range-legend-ruler style2">
                
                
              </div>
              <div class="range-legend-content">
                <div class="min-range">Needs Adjustment</div>
                <div class="mid-range">Adequate</div>
                <div class="max-range">Well Adjusted</div>
              </div>
              <div class="fitting-info-content">
                <!--
                <div class="small-ranges">
                  
                  <div class="small-range">
                    <div class="fitting-info-title-small">Temple feel</div>
                    <div class="fitting-info-range">
              
                      <div class="range-content-wrap">
                        <div class="range-cursor-text" :class="{'right':earOcclusionInfo.split('-')[1]==100,'left':earOcclusionInfo.split('-')[1]==0}" :style="{ left: earOcclusionInfo.split('-')[1] + '%' }">
                          <div class="cursor-point"  :class="{'medium':earOcclusionInfo.split('-')[1]<70 && earOcclusionInfo.split('-')[1]>40,'low':earOcclusionInfo.split('-')[1]<=40}"></div>
                        </div>
                        <div class="range-content">
                          <div class="range-cursor" :class="{'medium':earOcclusionInfo.split('-')[1]<70 && earOcclusionInfo.split('-')[1]>40,'low':earOcclusionInfo.split('-')[1]<=40,'right':earOcclusionInfo.split('-')[1]==100,'left':earOcclusionInfo.split('-')[1]==0}" :style="{ left: earOcclusionInfo.split('-')[1] + '%' }"></div>
                        </div>
                      </div>
                      
                    </div>
                    <div class="range-legend-ruler little">
                     
                    
                      
                    </div>
                    <div class="range-legend-content">
                      <div class="min-range">Needs refining</div>
                      <div class="mid-range">Adequate</div>
                      <div class="max-range">Optimized</div>
                    </div>
                  </div>
                  <div class="small-range">
                    <div class="fitting-info-title-small">Length</div>
                    <div class="fitting-info-range">
              
                      <div class="range-content-wrap">
                        <div class="range-cursor-text" :class="{'right':earOcclusionInfo.split('-')[1]==100,'left':earOcclusionInfo.split('-')[1]==0}" :style="{ left: earOcclusionInfo.split('-')[1] + '%' }">
                          <div class="cursor-point"  :class="{'medium':earOcclusionInfo.split('-')[1]<70 && earOcclusionInfo.split('-')[1]>40,'low':earOcclusionInfo.split('-')[1]<=40}"></div>
                        </div>
                        <div class="range-content">
                          <div class="range-cursor" :class="{'medium':earOcclusionInfo.split('-')[1]<70 && earOcclusionInfo.split('-')[1]>40,'low':earOcclusionInfo.split('-')[1]<=40,'right':earOcclusionInfo.split('-')[1]==100,'left':earOcclusionInfo.split('-')[1]==0}" :style="{ left: earOcclusionInfo.split('-')[1] + '%' }"></div>
                        </div>
                      </div>
                      
                    </div>
                    <div class="range-legend-ruler little">
                     
                    </div>
                    <div class="range-legend-content">
                      <div class="min-range">Needs refining</div>
                      <div class="mid-range">Adequate</div>
                      <div class="max-range">Optimized</div>
                    </div>
                  </div>
                  
                </div>
                <br />
              -->
                <span class="grey">
                  Ear comfort 
                  <template v-if="earOcclusionInfo.split('-')[1]>=70">
                    is well adjusted
                  </template>
                  <template v-else-if="earOcclusionInfo.split('-')[1]>=40">
                  
                    is adequate 
                  </template>
                  <template v-else>
                    needs adjustment 
                  </template>
                  - temples feel 

                  <template v-if="earOcclusionInfo.split('-')[1]>50">
                    secure
                  </template>
                  <template v-else-if="earOcclusionInfo.split('-')[1]>40">
                  
                    tight
                  </template>

                  <template v-else>
                    
                    loose
                  </template>.
                  <!--
                  and the length is 
                  <template v-if="templeLengthInfo.split('-')[1]>60">
                    good
                  </template>
                  <template v-else-if="templeLengthInfo.split('-')[1]>40">
                  
                    long
                  </template>

                  <template v-else>
                    
                    short
                  </template>.
                  -->
                  <template v-if="glass.id==58 || glass.id==45">
                    <br />
                    *This frame has adjustable temples
                  </template>
                </span>
              </div>
            </div>
          </div>
          </div>
        </template>

        </div>
      
 
      </div>
  
    </div>
  </b-overlay>
</template>

<script>

import {BModal, BButton,BOverlay, VBModal, BRow, BCard, BCardText, BAvatar, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, } from 'bootstrap-vue'
import {APIRequest, Woocommerce} from '@simb2s/senseye-sdk'
import { fetchPointCloudText } from '@/utils/fetchPointCloud'
import { VueGoodTable } from 'vue-good-table'
import ScanPopup from '../../components/ScanPopup.vue'
import PrescriptionPopup from '../../components/PrescriptionPopup.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import emitter from 'tiny-emitter/instance'
import ScanCanvas from './ScanCanvasNew.vue'
import ScanViewer from './ScanViewer.vue'
import html2pdf from "html2pdf.js";
import ScanCanvasPopup from './ScanCanvasPopup.vue'

export default {
  components: {
    BCard,
    BCardText,
    VueGoodTable,
    BAvatar,
    BOverlay,
    BBadge,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BModal,
    BButton,
    BRow,
    ScanPopup,
    PrescriptionPopup,
    ScanCanvas,
    ScanViewer,
    ScanCanvasPopup
  },
  data() {
    return {
      scan:null,
      glass:null,
      pointCloudLineCount: null,
      sizeFeedBackInfo:null,
      goodAdjustments:null,
      goodEyeToLensDistance:null,
      goodPupillaryHeight:null,
      framePositionInfo:null,
      noseComfortInfo:null,
      faceAngleInfo:null,
      casterAngleInfo:null,
      earFitInfo:null,
      earOcclusionInfo:null,
      templeLengthInfo:null,
      selectedScan:localStorage.senseye_b2b_selected_scan,
      loading:true,
      measurements:null,
      fittingLogs:null,
      recommendedSize:"S",
      globalFitScore:"medium",
      XSScore:null,
      SScore:null,
      MScore:null,
      LScore:null,
      XLScore:null,
      frameSizeNegativeXS:null,
      frameSizeNegativeS:null,
      frameSizeNegativeM:null,
      frameSizeNegativeL:null,
      frameSizeNegativeXL:null,
      framePositionNegativeXS:null,
      framePositionNegativeS:null,
      framePositionNegativeM:null,
      framePositionNegativeL:null,
      framePositionNegativeXL:null,
      noseComfortNegativeXS:null,
      noseComfortNegativeS:null,
      noseComfortNegativeM:null,
      noseComfortNegativeL:null,
      noseComfortNegativeXL:null,
      earOcclusionNegativeXS:null,
      earOcclusionNegativeS:null,
      earOcclusionNegativeM:null,
      earOcclusionNegativeL:null,
      earOcclusionNegativeXL:null,
      frameSizeResultXS:null,
      frameSizeResultS:null,
      frameSizeResultM:null,
      frameSizeResultL:null,
      frameSizeResultXL:null,
      framePositionResultXS:null,
      framePositionResultS:null,
      framePositionResultM:null,
      framePositionResultL:null,
      framePositionResultXL:null,
      noseComfortResultXS:null,
      noseComfortResultS:null,
      noseComfortResultM:null,
      noseComfortResultL:null,
      noseComfortResultXL:null,
      earOcclusionResultXS:null,
      earOcclusionResultS:null,
      earOcclusionResultM:null,
      earOcclusionResultL:null,
      earOcclusionResultXL:null,
      measuresDisplay:false,
      scanUrl:''
    }
  },
  
  methods:{
    displayMeasurements() {
      this.measuresDisplay=true
    },
    isSizeInGoodAdjustments(size) {
      if (!this.goodAdjustments || !Array.isArray(this.goodAdjustments)) return false;
      if (size === undefined || size === null) return false;
      const normalizedSize = String(size).trim().toLowerCase();
      return this.goodAdjustments.some(item => String(item).trim().toLowerCase() === normalizedSize);
    },
   
    async getScan() {
      let scan=await APIRequest.detail('scans',this.$route.params.id)
      this.scan={}
      this.scanUrl='http://35.180.177.138:8080/scans/proc/'+scan.id+'.fbx'
    
      this.scan=scan
      let pointCloud=await APIRequest.get_request('api/scans/point-cloud/'+scan.id)
 
 if (pointCloud.data.pointCloud) {
   try {
     const text = pointCloud.data.pointCloud
          // filter(Boolean) removes empty last line if file ends with \n
          this.pointCloudLineCount = text.split('\n').filter(Boolean).length
          
        } catch (e) {
          console.error('Error fetching point cloud file', e)
        }
      }
      if(scan.measurements)
      {
        let measurements=scan.measurements.replace('."',',"')
        measurements=measurements.replace('."',',"')
        measurements=measurements.replace('."',',"')
        measurements=measurements.replace('."',',"')
        
    
        this.measurements=JSON.parse(measurements)

      }
      
   
      //import data from "/Users/Documents/workspace/test.json"
    },
    async getFittingLogs() {
      let scan=await APIRequest.list_with_request('fitting-results','?scan='+this.$route.params.id+'&glass='+this.$route.params.glass_id+'&limit=1')
       
      this.goodAdjustments=scan[0][0].good_adjustments.split('-')

      this.glass=await APIRequest.detail('glasses',this.$route.params.glass_id)      
      if(scan[0][0].final_size=='xs')
      {
        this.sizeFeedBackInfo=scan[0][0].size_feedback_result_xs
        this.framePositionInfo=scan[0][0].frame_position_result_xs
        this.noseComfortInfo=scan[0][0].nose_fit_result_xs
        this.faceAngleInfo=scan[0][0].face_angle_result_xs
        this.casterAngleInfo=scan[0][0].caster_angle_result_xs
        this.earFitInfo=scan[0][0].ear_fit_result_xs
        this.earOcclusionInfo=scan[0][0].ear_occlusion_result_xs
        this.templeLengthInfo=scan[0][0].temple_length_result_xs
        this.goodEyeToLensDistance=scan[0][0].eye_to_lens_distance_xs
        this.goodPupillaryHeight=scan[0][0].pupillary_height_xs
      }
      else if(scan[0][0].final_size=='s')
      {
        this.sizeFeedBackInfo=scan[0][0].size_feedback_result_s
        this.framePositionInfo=scan[0][0].frame_position_result_s
        this.noseComfortInfo=scan[0][0].nose_fit_result_s
        this.faceAngleInfo=scan[0][0].face_angle_result_s
        this.casterAngleInfo=scan[0][0].caster_angle_result_s
        this.earFitInfo=scan[0][0].ear_fit_result_s
        this.earOcclusionInfo=scan[0][0].ear_occlusion_result_s
        this.templeLengthInfo=scan[0][0].temple_length_result_s
        this.goodEyeToLensDistance=scan[0][0].eye_to_lens_distance_s
        this.goodPupillaryHeight=scan[0][0].pupillary_height_s
      }
      else if(scan[0][0].final_size=='m')
      {
        this.sizeFeedBackInfo=scan[0][0].size_feedback_result_m
        this.framePositionInfo=scan[0][0].frame_position_result_m
        this.noseComfortInfo=scan[0][0].nose_fit_result_m
        this.faceAngleInfo=scan[0][0].face_angle_result_m
        this.casterAngleInfo=scan[0][0].caster_angle_result_m
        this.earFitInfo=scan[0][0].ear_fit_result_m
        this.earOcclusionInfo=scan[0][0].ear_occlusion_result_m
        this.templeLengthInfo=scan[0][0].temple_length_result_m
        this.goodEyeToLensDistance=scan[0][0].eye_to_lens_distance_m
        this.goodPupillaryHeight=scan[0][0].pupillary_height_m
      }
      else if(scan[0][0].final_size=='l')
      {
        this.sizeFeedBackInfo=scan[0][0].size_feedback_result_l
        this.framePositionInfo=scan[0][0].frame_position_result_l
        this.noseComfortInfo=scan[0][0].nose_fit_result_l
        this.faceAngleInfo=scan[0][0].face_angle_result_l
        this.casterAngleInfo=scan[0][0].caster_angle_result_l
        this.earFitInfo=scan[0][0].ear_fit_result_l
        this.earOcclusionInfo=scan[0][0].ear_occlusion_result_l
        this.templeLengthInfo=scan[0][0].temple_length_result_l
        this.goodEyeToLensDistance=scan[0][0].eye_to_lens_distance_l
        this.goodPupillaryHeight=scan[0][0].pupillary_height_l
      }
      else if(scan[0][0].final_size=='xl')
      {
        this.sizeFeedBackInfo=scan[0][0].size_feedback_result_xl
        this.framePositionInfo=scan[0][0].frame_position_result_xl
        this.noseComfortInfo=scan[0][0].nose_fit_result_xl
        this.faceAngleInfo=scan[0][0].face_angle_result_xl
        this.casterAngleInfo=scan[0][0].caster_angle_result_xl
        this.earFitInfo=scan[0][0].ear_fit_result_xl
        this.earOcclusionInfo=scan[0][0].ear_occlusion_result_xl
        this.templeLengthInfo=scan[0][0].temple_length_result_xl
        this.goodEyeToLensDistance=scan[0][0].eye_to_lens_distance_xl
        this.goodPupillaryHeight=scan[0][0].pupillary_height_xl
      }
      this.fittingLogs=scan[0][0]
    

      //import data from "/Users/Documents/workspace/test.json"
    },
    selectScan(id) {
      this.selectedScan=this.scan.id
      localStorage.senseye_b2b_selected_scan=this.scan.id
   
    },
    
    
  },
  watch:{
    
  },
  async mounted()
  {
    if(this.$route.params.token)
    {
      localStorage.token_senseye_auth=this.$route.params.token
    }
    this.loading=true
    
    
    await this.getFittingLogs()
    await this.getScan()
    this.loading=false
  }
}
</script>


<style lang="scss" >
@import '@core/scss/vue/libs/vue-good-table.scss';



.measurement-title
{
  border-radius: 5px;
  background:#63ff2b;
  padding:5px 15px;
  width: fit-content;
  margin-bottom:10px;
}
.measurement-content .label 
{
  color:#999;
}
.measurement-content
{
  display:flex;
  flex-direction: row;
  
  align-items: center;
  justify-content: space-between;
}
.fitting-info-content .grey
{
  color:#999;
}
.fitting-info-content
{
  background:#f1f1f1;
  padding:9px 18px;
  margin-top:10px;
  border-radius: 5px;
}
.fitting-info-title
{
  font-size:16px;
  margin-bottom:20px;
 
}
.button-close
{
  padding:7px 12px;
  border-radius: 5px;
  background:#f1f1f1;
  position:absolute;
  right:20px;
  top:20px;
  cursor:pointer;
}
.little-fit-balise
{
  position:absolute;
  top:0;
  padding:5px 7px !important;
  right:0;
}
.fitting-info 
{
  width:50%;
  background:#fff;
  margin-top:20px;
 
 
  position:relative;
}
.cursor-point.low,.range-cursor.low 
{
  background:#FF9900;
}
.cursor-point.good,.range-cursor.good 
{
  background:#2AC770;
}
.cursor-point.medium,.range-cursor.medium 
{
  background:#0088FF;
}

.cursor-point
{
  width:17px;
  height:17px;
  border-radius: 50%;
  position:absolute;
  top:50%;
  left:50%;
  transform: translate(-50%,-50%);
  background:#2AC770;
}
.range-cursor-text .text
{
  min-width:100px;
  text-align: center;
  position:absolute;
 
  left:50%;
  transform: translateX(-50%);
 
}
.range-cursor-text 
{
  width:20%;

  text-align: center;
  position:absolute;
  top:2px;
  left:50%;
  transform: translateX(-50%);
  font-size:12px;
  line-height:14px;
}
.range-cursor-text.right
{
  transform: translateX(-100%);
}
.range-cursor.right
{
  transform: translateX(-100%);
}
.range-cursor.left,.range-cursor-text.left
{
  transform: none;
}
.range-cursor 
{
  
  position:absolute;
  top:0;
  left:0;

  height:100%;
  background:#2AC770;
}
.fitting-infos 
{
  margin-top:20px;
  display:flex;
  flex-direction: row;
  align-items: flex-start;
  gap:20px;
  width:100%;
}
.desc-bottom .grey
{
  color:#999;
}
.range-content-wrap 
{
  flex:1;



  position:relative;
}
.range-content 
{
  flex:1;
  height:5px;
  overflow:hidden;
  background:#99999930;
  border-radius: 5px;
  position:relative;
}
.fitting-info-range 
{
  margin-top:25px;
  display:flex;
  flex-direction: row;
  gap:20px;
  color:#999;
  width:100%;
  font-size:12px;
  align-items: center;
  justify-content: center;
}
.desc-bottom 
{
  padding:5px 10px;
  border-radius: 5px;
  background:#f1f1f1;
  margin-top:10px;
}
.fit-balise.good 
{
  background:#DBF6E7;
  color:#10C05F;
}
.fit-balise.low 
{
  background:#FFF0D9;
  color:#FF9900;
}
.fit-balise.medium 
{
  color:#0088FF;
  background:#D9EDFF;
}
.sizename
{
  text-transform: uppercase;
}
.right-item .label
{
  color:#999;
}
.fit-balise 
{
  margin-bottom:0px;
  width:fit-content;
  display:flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap:10px;
  padding:9px 10px;
  border-radius: 5px;
}
.title-line .left .fit-balise
{
  font-size:12px;
  margin-bottom: 0 !important;
}
.title-line .left
{
  font-size:40px;
}
.title-line .right
{
  display:flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap:20px;
}
.title-line .right-item
{
  display:flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;

}
.title-line
{
  display:flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-end;
  width:100%;
  margin-bottom:20px;
}
.size.active .size-name 
{
  background:#f1f1f1;

}
.size-name 
{
 
  padding:5px 10px;
  color:#000;
  border-radius: 5px;

  bottom:10px;
}
.size.good .size-score
{
  background-color: #10C05F30;
}
.size.active .size-score
{
  background-color: #10C05F;
}
.size-score
{
  border-radius: 5px;
 
  position:absolute;
  bottom:0;
  width:100%;
  background-color: #99999930;
}
.size
{
  position:relative;
  display:flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap:10px;
  width:18%;
}
.size-content
{
  border-radius: 5px;

  width:100%;
  height:180px;
  position:relative;
  background-color: #f1f1f1;
}
.trait 
{
  position:absolute;
  left:0;
  top:144px;
  width:100%;
  height:1px;
  background-color: #999;
}
.recommended-sizes
{
  padding-top: 20px;
  display:flex;
  flex-direction: row;
  gap:10px;
  position:relative;
  justify-content: center;
  min-height:165px;
}
.fitting-container
{
  font-weight:400;
  font-family:"degular";
  color:#000;
  font-size:12px;
 background-color: #fff;
 min-height:100vh;
 padding-bottom:50px;
}
.fitting-content
{
  display:flex;
  max-width:964px ;
  flex-direction: column;
  width:80%;
  margin-left: auto;
  margin-right: auto;
  padding-top: 50px;
}
.fitting-top .fitting-info
{
  padding:10px;
  border-radius: 5px;
  margin-right:20px;
  margin-bottom:20px;
}
.fitting-top
{
  gap:0px;
  display:flex;
  flex-direction: row;
  width:100%;
  background:#f1f1f1;
 
  border-radius: 5px;
}
.recommended .b 
{
  font-weight: 600;
}
.recommended
{
  color:#000;
  font-size:14px;
}
.range-legend-content .max-range
{
  text-align: right;
}
.range-legend-content .mid-range
{
  position:absolute;
  left:50%;
  transform: translateX(-50%);
}
.range-legend-content
{
  position:relative;
  display: flex;
  width:100%;
  justify-content: space-between;
  gap:14px;
  color:#999;
  overflow:hidden;
}
.small-ranges .range-legend-ruler
{
  gap:5px !important;
}
.small-ranges .range-legend-content
{
  font-size:10px;
}
.small-range
{
  width:50%;
}
.small-ranges 
{
  display:flex;

  gap:10px;
}
.range-legend-ruler.little
{
  background: repeating-linear-gradient(
    90deg,
    transparent 0,
    transparent 4px,
    rgba(0,0,0,0.1) 4px,
    rgba(0,0,0,0.1) 5px
  );
}
.range-legend-ruler.style2
{
  background-image:url('/assets/images/jauge-bg2.png');
}
.range-legend-ruler
{
  width:100%;
  display: flex;
  justify-content: center;
  gap:14px;
  color:#999;
  overflow:hidden;
  background-image:url('/assets/images/jauge-bg1.png');
  margin-top:10px;
  margin-bottom:10px;
  /* Graduated ruler: minor tick marks only */
 
  background-size: 100% 100%;
  height:30px;
}
.fitting-description
{
 
  display:flex;
  margin-top:20px;
  margin-right:20px;
  margin-bottom:20px;
  background:#fff;
  padding:20px;
  border-radius: 5px;
  justify-content: space-between;
  flex-direction: column;

  width: 50%;
}
.scans-canvas
{
  display:flex;
  width:55%;
  flex-direction: row;
  height:100%;
  border-radius: 5px;
 
}

.overlay-scan {
  width:100%;
  height:100vh;
  z-index:999999;
}
#element-to-convert
{
  padding-left:20px;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
}

.title-icon img 
{
  height:15px;
}
.popup-content-inner .title-icon
{
  background:#fff;
}
.title-icon
{
  width:30px;
  height:30px;
  border-radius: 5px;
  background:#f1f1f1;
  display:flex;
  align-items: center;
  justify-content: center;
}
.date
{
  color:#999;
  margin-left:40px;
  margin-right:20px;
}
.scan-button
{
  display:flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap:15px;
  background:#f1f1f1;
  padding:5px;
  border-radius: 5px;
}
.initiales
{
  background:#fff;
  padding:5px 12px;
  color:#999;
  border-radius: 5px;
}
.scan-measures .title 
{
  margin-bottom:0px;
  font-size:14px;
  display:flex;
  color:#000;

  align-items: center;
  justify-content: flex-start;
  gap:10px;
}
.label
{
  color:#999;
  font-size:12px;
}
.value
{
  float:right;
  color:#000;
  font-size:12px;
}
.scan-name
{
  display:flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  color:#000;
  z-index: 2;
  font-size:14px;

  position: absolute;
  top:0px;
  left:0px;
}
.popup-top .scan-name
{
  position: absolute;
  bottom:20px;
  width:calc(100% - 40px);
 display:block;
top:auto;
  left:20px;
}
.popup-top .initiales
{
  background:#f1f1f1;
}
.popup-top .scan-button 
{
  justify-content: flex-start;
  background:#fff;
}
.popup-content-inner
{
  position: relative;
  width:100%;
  height:100%;
  padding:20px;
  position:relative;
  background:#fff;
  border-radius: 5px;
}
.popup-content
{
  max-width:964px;
  margin-left: auto;
  margin-right: auto;
  width:80%;
  padding:20px;
}
.popup-top
{
  position: relative;
  
}
.measurements-container 
{
  position:fixed;
  top:0;
  left:0;
  overflow-y: auto;
  height:100vh;
  width:100%;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  background-color: rgba(255, 255, 255, 0.1);
  z-index: 999999;

  
}
.close-button img
{
  transform: rotate(180deg);
}
.close-button
{
  position:absolute;
  top:20px;
  left:20px;
  cursor:pointer;
  background:#fff;
  border-radius: 5px;
  z-index:5;
  width:32px;
  height:32px;
  display:flex;
  align-items: center;
  justify-content: center;
}
.measures-half
{
  display:flex;
  gap:20px;
  justify-content: space-between;
  margin-top:20px;
}
.measures-small
{
  background:#f1f1f1;
  padding:20px;
  width:50%;
  border-radius: 5px;
  
}
.measures-big
{
  background:#f1f1f1;
  padding:20px;
  border-radius: 5px;
  margin-top:20px;
}

.popup-top .points-count
{

  text-align:right;
  position:absolute;
  left:auto;
  right:20px;
  bottom:auto;
  top:20px;
  z-index:5;

}
.points-count
{
  text-align:left;
  position:absolute;
  left:0px;
  bottom:0px;
  z-index:5;
}
.popup-top .scans-canvas
{
  display:flex;
  width:100%;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height:100%;
}
@media (orientation: landscape) {
  .fitting-content
  {
    max-width: 2000px !important;
    width: 90% !important;
  }
  .fitting-content-inner
  {
    display:flex;
    align-items: center;
  }
  .fitting-infos-content
  {
    width: 50% !important;
    padding-left:20px;
  }
  .fitting-top
  {
    width: 50% !important;
    display:flex;
    flex-direction: column;
  }
  .fitting-description
  {
    position:relative;
    left:20px;
    width:calc(100% - 40px) !important;
  }
  .scans-canvas
  {
    width:100% !important;
  }
  .size-content
  {
    height:95px !important;
  }
  .popup-content
  {
    width:90% !important;
    max-width: 2000px !important;
  }

  .popup-top
  {
    width:50% !important;
  }

  .measures-big
  {
    margin-top:0px !important;
  }
  .popup-content-inner

  {
    display:flex;
  }
  .measures-content-inner
  {
    margin-left:20px;
  }
}


</style>
